function removeEmptyValues(data, excluded = []) {
  if (Array.isArray(data)) {
    return data.filter((item) => !!item);
  }
  return Object.entries(data).reduce((param, [key, value]) => {
    if (excluded.includes(key)) {
      if (!!value && !!value.length) {
        return {
          ...param,
          [key]: value
        };
      } else {
        return param;
      }
    } else {
      return { ...param, [key]: value };
    }
  }, {});
}
const removeEmptyNestedValues = (object) => {
  return Object.keys(object).reduce((acc, curr) => {
    const isNotNull = object[curr] !== null;
    if (isNotNull) {
      Object.keys(object[curr]).filter((currentKey) => !!object[curr][currentKey]).forEach((currentKey) => {
        if (!acc[curr]) {
          acc[curr] = {};
        }
        Object.assign(acc[curr], {
          [currentKey]: object[curr][currentKey]
        });
      });
    }
    return acc;
  }, {});
};
function removeEmptyProps(obj) {
  return Object.entries(obj).filter(([_, v]) => v != null).reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {});
}
const getCookie = (name) => {
  const regex = new RegExp(
    `(?:^|; )${name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1")}=([^;]*)`
  );
  const matches = regex.exec(document.cookie);
  return matches ? decodeURIComponent(matches[1]) : null;
};
var CookieTypes = /* @__PURE__ */ ((CookieTypes2) => {
  CookieTypes2["preferredLanguage"] = "preferred-language";
  CookieTypes2["preferredLanguageSPA"] = "preferred-language-client";
  CookieTypes2["unicBrowserCode"] = "ubc-code";
  return CookieTypes2;
})(CookieTypes || {});
const setCookie = (name, value, options = {}) => {
  var _a;
  const cookieOptions = { path: "/", ...options };
  if ((_a = cookieOptions.expires) == null ? void 0 : _a.toUTCString) {
    cookieOptions.expires = cookieOptions.expires.toUTCString();
  }
  let updatedCookie = `${encodeURIComponent(name)}=${encodeURIComponent(
    value
  )}`;
  for (const optionKey in cookieOptions) {
    if (cookieOptions.hasOwnProperty(optionKey)) {
      updatedCookie += `; ${optionKey}`;
      const optionValue = cookieOptions[optionKey];
      if (optionValue !== true) {
        updatedCookie += `=${optionValue}`;
      }
    }
  }
  document.cookie = updatedCookie;
};
const deleteCookie = (name) => {
  setCookie(name, "", { "max-age": -1 });
};
const expireCookie = (value) => {
  const time = value || 15 * 60 * 1e3 * 1e5;
  return new Date((/* @__PURE__ */ new Date()).getTime() + time);
};
const setPreferredLanguage = (isoLanguage) => {
  const expires = expireCookie(30 * 60 * 1e3 * 1e5);
  let cookieName = "preferred-language";
  if (window.spa) {
    if (getCookie(
      "preferred-language"
      /* preferredLanguage */
    )) {
      deleteCookie(
        "preferred-language"
        /* preferredLanguage */
      );
    }
    cookieName = "preferred-language-client";
  }
  setCookie(cookieName, isoLanguage, { expires });
};
const strictStringSearch = (value, searchValue) => {
  const valueArr = typeof value === "string" ? [value] : value;
  const valueArray = (searchValue.toLowerCase() || "").trim().split("");
  const item1ValueArray = valueArr[0].toLowerCase().split("");
  const item2ValueArray = valueArr[1] ? valueArr[1].toLowerCase().split("") : "";
  return valueArray.every(
    (current, i) => current === item1ValueArray[i] || item2ValueArray.length && current === item2ValueArray[i]
  );
};
const stringSearch = (value, searchValue) => {
  const valueArr = typeof value === "string" ? [value] : value;
  return valueArr.filter((item) => item.toLowerCase().includes((searchValue || "").toLowerCase().trim()))[0];
};
const searchByString = (string, searchValue, strict) => strict ? strictStringSearch(string, searchValue) : stringSearch(string, searchValue);
const updateFilters = (name, value, filters) => {
  const filtersStore = { ...filters };
  filtersStore[name] = value;
  return filtersStore;
};
const utcNow = () => {
  const now = /* @__PURE__ */ new Date();
  const time = now.getTime();
  let offset = now.getTimezoneOffset();
  offset *= 6e4;
  return time - offset;
};
const supportsWebp = async () => {
  if (!self.createImageBitmap) return false;
  const webpData = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=";
  const blob = await fetch(webpData).then((r) => r.blob());
  return createImageBitmap(blob).then(
    () => true,
    () => false
  );
};
const isIos = () => [
  "iPad Simulator",
  "iPhone Simulator",
  "iPod Simulator",
  "iPad",
  "iPhone",
  "iPod"
].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
const loadScripts = () => {
  const documentLazyScripts = document.querySelectorAll("lazyScript");
  documentLazyScripts.forEach((script) => {
    const addedScript = document.createElement("script");
    const data = script.innerText;
    addedScript.type = "text/javascript";
    addedScript.textContent = data;
    try {
      document.body.appendChild(addedScript);
    } catch (e) {
      return null;
    }
  });
};
const cutStringToFixed = (stringToCut, symbolCount = 8) => stringToCut.length > symbolCount ? `${stringToCut.slice(0, symbolCount)}...` : stringToCut;
const userNameMask = (nameToCut, symbolCount = 4) => `${(nameToCut.length > symbolCount ? nameToCut.slice(0, symbolCount) : nameToCut).trim()}**`;
const DEV_FEATURE_ACTIVATE_URL_PARAM = "activate";
const isSpa = () => window.spa;
const getCmsRoutes = () => window.paths;
const getIsTextPage = () => {
  const paths = getCmsRoutes();
  const currentPath = window.location.pathname;
  if (!paths || !Array.isArray(paths)) {
    return false;
  }
  return paths.some((item) => item.path !== "/" && currentPath.includes(item.path));
};
const appendScripts = (scriptsString, holder = document.body, callback) => {
  const temp = document.createElement("div");
  temp.innerHTML = scriptsString;
  const scriptSet = [];
  const scriptPromises = [];
  const headScripts = temp.querySelectorAll("script");
  (headScripts || []).forEach((headScript) => {
    const script = document.createElement("script");
    script.setAttribute("defer", "true");
    if (headScript.type) {
      script.type = headScript.type;
    }
    if (headScript.src) {
      script.src = headScript.src;
      const scriptLoadedPromise = new Promise((resolve, reject) => {
        script.onload = () => resolve(headScript.src);
        script.onerror = (error) => reject(error);
      });
      scriptPromises.push(scriptLoadedPromise);
    }
    if (headScript.innerHTML) {
      script.innerHTML = headScript.innerHTML;
    }
    scriptSet.push(script);
    script.remove();
  });
  scriptSet.forEach((script) => {
    try {
      holder.appendChild(script);
    } catch (e) {
      console.error(e);
    }
  });
  const results = [];
  let promiseChain = Promise.resolve();
  scriptPromises.forEach((promise) => {
    promiseChain = promiseChain.then(() => promise).then((result) => {
      results.push(result);
    }).catch((error) => {
      console.info("error", error);
    });
  });
  promiseChain.then(() => {
    if (callback) {
      callback(results);
    }
  });
  temp.remove();
};
const isAdditionalSiteLink = (path) => {
  return path.startsWith("https://") || path.startsWith("http://");
};
export {
  CookieTypes,
  DEV_FEATURE_ACTIVATE_URL_PARAM,
  appendScripts,
  cutStringToFixed,
  deleteCookie,
  expireCookie,
  getCmsRoutes,
  getCookie,
  getIsTextPage,
  isAdditionalSiteLink,
  isIos,
  isSpa,
  loadScripts,
  removeEmptyNestedValues,
  removeEmptyProps,
  removeEmptyValues,
  searchByString,
  setCookie,
  setPreferredLanguage,
  supportsWebp,
  updateFilters,
  userNameMask,
  utcNow
};
